import { RichText as LexicalRichText } from "@payloadcms/richtext-lexical/react";
import type { SerializedEditorState } from "@payloadcms/richtext-lexical/lexical";
import type { Page } from "@/payload-types";

/** Shape Payload generates for every richText field. */
export type RichTextData = NonNullable<NonNullable<Page["legal"]>["body"]>;

/** Render a Lexical editor state as HTML. Styling comes from the surrounding `.prose-cw`. */
export function Lexical({ data }: { data: RichTextData | null | undefined }) {
  if (!data) return null;
  return <LexicalRichText data={data as unknown as SerializedEditorState} disableContainer />;
}
